module.exports = __webpack_public_path__ + "img/qdaqicon.bebcb586.svg";